import React from 'react'
import './styles.scss'
import { Redirect, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Field, reduxForm, getFormValues, getFormSyncErrors } from 'redux-form'
import PhoneInput from '../../PhoneInput/phoneInput'
import validators from '../../../utils/validators'
import editableFleetAdminActions from '../../../store/actions/editableFleetAdmin'
import userActions from '../../../store/actions/users'
import renderInput from '../../../utils/renderInput'
import forgotPassword from '../../../services/forgotPassword'
import usersService from '../../../services/usersService'
import countryList from 'country-list'
import renderSelect from '../../../utils/renderSelect'
import DeleteConfirmationDialog from '../../DeleteConfirmationDialog/deleteConfirmationDialog'
import CountryDefaultOption from '../../CountryDefaultOption/CountryDefaultOption'

class EditableFleetAdminInformationForm extends React.Component {

    state = {
        backClicked: false,
        displayErrors: false,
        isEditable: false,
        buttonsDisabled: true,
        showDeleteConfirmationDialog: false
    }

    componentDidMount() {
        const { updateTitle, snackbarRef } = this.props

        if (this.props.fleetAdminId !== 'new') {
            this.props.selectFleetAdminInfo(this.props.fleetAdminId)
                .then(() => {
                    updateTitle(`${this.props.editableFleetAdmin.data.lastName} ${this.props.editableFleetAdmin.data.firstName}`)
                    this.setState({
                        buttonsDisabled: false
                    })
                })
                .catch(e => { snackbarRef.current.openSnackBar(e.message, { backgroundColor: '#a83256' }) })
        } else {
            this.setState({
                buttonsDisabled: false,
                isEditable: true
            })
        }
    }

    componentWillUnmount() {
        this.props.clearFleetAdminInfo()
    }

    setDisplayErrors = (val) => {
        this.setState({ displayErrors: val })
    }

    setBackClicked = (val) => {
        this.setState({ backClicked: val })
    }

    handleBackClicked = () => {
        if (this.props.fleetAdminId === 'new') {
            this.props.history.push('/devices')
        } else {
            if (this.state.isEditable) {
                this.setState({ isEditable: false })
            } else {
                this.setBackClicked(true)
            }
        }
    }

    handleSubmit = (event) => {
        const { currentFormValues, currentSyncErrors, saveFleetAdmin, snackbarRef } = this.props
        event.preventDefault()

        this.setState({ buttonsDisabled: true })

        for (const prop in currentSyncErrors) {
            if (currentSyncErrors.hasOwnProperty(prop)) {
                this.setDisplayErrors(true)
                this.setState({ buttonsDisabled: false })
                return
            }
        }

        saveFleetAdmin(this.props.fleetAdminId, currentFormValues)
            .then(() => {
                this.setState({ buttonsDisabled: false, isEditable: false })
                this.props.sendSignUpInfo(this.props.editableFleetAdmin.fleetAdminId)
                this.props.history.push(`/fleetAdmin/${this.props.editableFleetAdmin.fleetAdminId}`)
                this.props.resetEditableFleetAdminFormValues()
                this.props.selectFleetAdminInfo(this.props.editableFleetAdmin.fleetAdminId)
                    .then(() => {
                        this.props.updateTitle(`${this.props.editableFleetAdmin.data.lastName} ${this.props.editableFleetAdmin.data.firstName}`)
                        snackbarRef.current.openSnackBar('Fleet Admin has been saved', { backgroundColor: '#469D7C' })
                    })
            })
            .catch((e) => {
                snackbarRef.current.openSnackBar(e.message, { backgroundColor: '#a83256' })
                this.setState({ buttonsDisabled: false })
            })
    }

    handleBlockUnblock = (event) => {
        event.preventDefault()

        const { snackbarRef, editableFleetAdmin, setEditableFleetAdminInfo, fleetAdminId } = this.props

        const snackBarText = !editableFleetAdmin.data.isActive
            ? 'Fleet Admin was activated successfully.'
            : 'Fleet Admin was deactivated successfully.'

        this.setState({ buttonsDisabled: true })

        usersService.updateUser({ id: fleetAdminId, isActive: !editableFleetAdmin.data.isActive })
            .then((fleetAdmin) => {
                setEditableFleetAdminInfo(fleetAdmin)
                snackbarRef.current.openSnackBar(snackBarText, { backgroundColor: '#469D7C' })
                this.setState({ buttonsDisabled: false })
            })
            .catch(() => {
                snackbarRef.current.openSnackBar('There were some errors. Please try again later.', { backgroundColor: '#a83256' })
                this.setState({ buttonsDisabled: false })
            })
    }

    handleDelete = (event) => {
        event.preventDefault()
        this.setState({ showDeleteConfirmationDialog: true })
    }

    handleDeleteConfirmationClick = (val) => {
        if (val) {
            const { snackbarRef } = this.props

            this.setState({ buttonsDisabled: true })

            usersService.deleteUser(this.props.fleetAdminId)
                .then(() => {
                    this.props.history.push('/devices')
                    snackbarRef.current.openSnackBar('Fleet Admin was deleted successfully.', { backgroundColor: '#469D7C' })
                })
                .catch(() => {
                    snackbarRef.current.openSnackBar('There were some errors. Please try again later.', { backgroundColor: '#a83256' })
                    this.setState({ buttonsDisabled: false })
                })
        }

        this.setState({ showDeleteConfirmationDialog: false })
    }

    handlePasswordReset = (event) => {
        event.preventDefault()

        const { snackbarRef, editableFleetAdmin } = this.props

        this.setState({ buttonsDisabled: true })

        forgotPassword.sendForgotPasswordEmail(editableFleetAdmin.data.email)
            .then(() => {
                snackbarRef.current.openSnackBar('Reset password email was sent successfully.', { backgroundColor: '#469D7C' })
                this.setState({ buttonsDisabled: false })
            })
            .catch(() => {
                snackbarRef.current.openSnackBar('There were some errors. Please try again later.', { backgroundColor: '#a83256' })
                this.setState({ buttonsDisabled: false })
            })
    }

    render() {

        const { backClicked, displayErrors, buttonsDisabled } = this.state
        const { editableFleetAdmin } = this.props

        if (backClicked) {
            return <Redirect to='/devices' />
        }

        return (
            <>
                <DeleteConfirmationDialog show={this.state.showDeleteConfirmationDialog}
                    onClose={this.handleDeleteConfirmationClick}
                    warningText={<p>Are you sure you would like to delete Fleet Admin?</p>} />
                <form className='EditableFleetAdminInformationForm' onSubmit={this.handleSubmit}>
                    {
                        this.state.isEditable
                            ? <Field name='firstName' component={renderInput} label='First Name *' validate={validators.required} displayErrors={displayErrors} />
                            : <>
                                <label className="not-editable">First Name</label>
                                <div className='uneditable-form-field'>
                                    {editableFleetAdmin.data && editableFleetAdmin.data.firstName}
                                </div>
                            </>
                    }

                    {
                        this.state.isEditable
                            ? <Field name='lastName' component={renderInput} label='Last Name *' validate={validators.required} displayErrors={displayErrors} />
                            : <>
                                <label className="not-editable">Last Name</label>
                                <div className='uneditable-form-field'>
                                    {editableFleetAdmin.data && editableFleetAdmin.data.lastName}
                                </div>
                            </>
                    }

                    {
                        this.state.isEditable
                            ? <Field name='companyName' component={renderInput} label='Company Name' />
                            : <>
                                <label className="not-editable">Company Name</label>
                                <div className='uneditable-form-field'>
                                    {editableFleetAdmin.data && editableFleetAdmin.data.companyName}
                                </div>
                            </>
                    }

                    {
                        this.state.isEditable && this.props.fleetAdminId === 'new'
                            ? <Field name='signUpCode' component={renderInput} label='Sign Up Code *' validate={[validators.required, validators.signUpCode]} displayErrors={displayErrors} />
                            : <>
                                <label className="not-editable">Sign Up Code</label>
                                <div className='uneditable-form-field'>
                                    {editableFleetAdmin.data && editableFleetAdmin.data.signUpCode}
                                </div>
                            </>
                    }

                    {
                        this.state.isEditable
                            ? <Field name='streetAddress' component={renderInput} label='Street Address' />
                            : <>
                                <label className="not-editable">Street Address</label>
                                <div className='uneditable-form-field'>
                                    {editableFleetAdmin.data && editableFleetAdmin.data.streetAddress}
                                </div>
                            </>
                    }

                    {
                        this.state.isEditable
                            ? <Field name='city' component={renderInput} label='City' displayErrors={displayErrors} />
                            : <>
                                <label className="not-editable">City</label>
                                <div className='uneditable-form-field'>
                                    {editableFleetAdmin.data && editableFleetAdmin.data.city}
                                </div>
                            </>
                    }

                    {
                        this.state.isEditable
                            ? <Field name='state' component={renderInput} label='State/Province' displayErrors={displayErrors} />
                            : <>
                                <label className="not-editable">State/Province</label>
                                <div className='uneditable-form-field'>
                                    {editableFleetAdmin.data && editableFleetAdmin.data.state}
                                </div>
                            </>
                    }

                    {
                        this.state.isEditable
                            ? <Field name='country' component={renderSelect} label='Country *' displayErrors={displayErrors} validate={validators.required} options={countryList.getData()}
                                displayFn={c => `${c.code} - ${c.name}`} getValueFn={c => `${c.code} - ${c.name}`} renderDefaultOption={() => <CountryDefaultOption disabled />} />
                            : <>
                                <label className="not-editable">Country</label>
                                <div className='uneditable-form-field'>
                                    {editableFleetAdmin.data && editableFleetAdmin.data.country}
                                </div>
                            </>
                    }

                    {
                        this.state.isEditable
                            ? <Field name='zip' component={renderInput} label='Zip/Postal Code' displayErrors={displayErrors} />
                            : <>
                                <label className="not-editable">Zip/Postal Code</label>
                                <div className='uneditable-form-field'>
                                    {editableFleetAdmin.data && editableFleetAdmin.data.zip}
                                </div>
                            </>
                    }

                    {
                        this.state.isEditable
                            ? <><label htmlFor='phone'>Cell Phone Number (Alerts)</label>
                                <Field name='phone' id='phone' component={PhoneInput} validate={validators.phone} /></>
                            : <>
                                <label className="not-editable">Cell Phone Number (Alerts)</label>
                                <div className='uneditable-form-field'>
                                    {editableFleetAdmin.data && editableFleetAdmin.data.phone}
                                </div>
                            </>
                    }

                    {
                        this.state.isEditable
                            ? <><label htmlFor='mobilePhone'>Contact Phone Number</label>
                                <Field id='mobilePhone' name='mobilePhone' component={PhoneInput} validate={validators.phone} /></>
                            : <>
                                <label className="not-editable">Contact Phone Number</label>
                                <div className='uneditable-form-field'>
                                    {editableFleetAdmin.data && editableFleetAdmin.data.mobilePhone}
                                </div>
                            </>
                    }

                    {
                        this.state.isEditable
                            ? <Field name='email' component={renderInput} label='Email *' type='email' validate={[validators.required, validators.email]} displayErrors={displayErrors} />
                            : <>
                                <label className="not-editable">Email</label>
                                <div className='uneditable-form-field'>
                                    {editableFleetAdmin.data && editableFleetAdmin.data.email}
                                </div>
                            </>
                    }

                    {
                        this.props.fleetAdminId === 'new'
                            ? <>
                                <Field name='password' component={renderInput} label='Password *' type='password' validate={validators.password} displayErrors={displayErrors} />
                                <Field name='confirmPassword' component={renderInput} label='Re-enter Password *' type='password' validate={validators.password} displayErrors={displayErrors} />
                            </>
                            : <></>
                    }

                    {
                        this.state.isEditable
                            ? <div className='required-label'>(*)<i>Required Fields</i></div>
                            : <>
                                <label className="not-editable">Regional Admin Contact Information</label>
                                <div className='uneditable-form-field'>
                                    {editableFleetAdmin.data && editableFleetAdmin.data.localAdminEmail}
                                </div>
                            </>
                    }

                    {
                        <div className='buttons-container'>
                            {
                                this.state.isEditable
                                    ? <input type='submit' value='Save' className='btn green big-radius shadow' disabled={buttonsDisabled} />
                                    : <input type='button' value='Edit' className='btn green big-radius shadow' disabled={buttonsDisabled} onClick={(e) => { e.preventDefault(); this.setState({ isEditable: true }) }} />
                            }
                            {
                                this.props.fleetAdminId === 'new'
                                    ? <></>
                                    : <>
                                        <input type='button' value='Password Reset' className='btn green big-radius shadow'
                                            disabled={this.state.isEditable || buttonsDisabled} onClick={e => this.handlePasswordReset(e)} />
                                        <input type='button' value={editableFleetAdmin.data && editableFleetAdmin.data.isActive ? 'Deactivate' : 'Activate'}
                                            className='btn yellow big-radius shadow' disabled={this.state.isEditable || buttonsDisabled}
                                            onClick={e => this.handleBlockUnblock(e)} />
                                        <input type='button' value='Delete' className='btn red big-radius shadow'
                                            disabled={this.state.isEditable || buttonsDisabled} onClick={e => this.handleDelete(e)} />
                                    </>
                            }
                        </div>
                    }
                </form>
            </>
        )
    }
}

const stateToProps = state => ({
    initialValues: state.editableFleetAdmin.data,
    currentFormValues: getFormValues('editableFleetAdminInformationForm')(state),
    currentSyncErrors: getFormSyncErrors('editableFleetAdminInformationForm')(state),
    snackbarRef: state.common.snackbarReference,
    editableFleetAdmin: state.editableFleetAdmin
})

const dispatchToProps = {
    ...editableFleetAdminActions,
    sendSignUpInfo: userActions.sendSignUpInfo
}

EditableFleetAdminInformationForm = reduxForm({
    form: 'editableFleetAdminInformationForm',
    enableReinitialize: true
})(EditableFleetAdminInformationForm)

export default connect(stateToProps, dispatchToProps)(withRouter(EditableFleetAdminInformationForm))
